/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import MoserObject from './MoserObject';
import ModuleUtils from './ModuleUtils';
import EditModeType from './EditModeType';
import MoserObjectUtils from './MoserObjectUtils';
import FacetTypeEnabled from './FacetTypeEnabled';
import ValueSearchType from './ValueSearchType';
import PropertySetter from './PropertySetter';
import ReferenceResolver from './ReferenceResolver';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (runtime) // getModuleObject
//@import com/ibm/bi/platform/moser/core/module/util/ModuleUtils (runtime) // getIdGenerator, getSourceModuleAliasIfNotDefined
//@import com/ibm/bi/platform/moser/common/generated/metadata/EditModeType (runtime) // EditModeType
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // getGlobalCalculations, getItems
//@import com/ibm/bi/platform/moser/common/generated/metadata/FacetTypeEnabled (runtime) // FacetTypeEnabled
//@import com/ibm/bi/platform/moser/common/generated/metadata/ValueSearchType (runtime) // ValueSearchType
//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertySetter (runtime) // getParentQuerySubject
//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (runtime) // getQueryItemByIdAndQuerySubject, findRefById

/**
 * for legacy insert function.
 */
export default class LegacyInsertor extends BaseMoserObject{

	module = null;

	srcModule = null;

	srcModuleId = null;

	asReference = false;

	objToInsertList = null;

	idGenerator = null;

	queryItemWithCustomsortToInsertList = null;

	calculationWithCustomsortToInsertList = null;

	refCustomSortOldToNewID = null;

	bHasRefCustomSortOldToNewID = false;

	copyCustomSortOldToNewID = null;

	bHasCopyCustomSortOldToNewID = false;



	/**
	 * @param {ObjectType} destParent
	 * @param {Array} objs
	 * @param {String} srcMid
	 * @param {Module} srcM
	 * @param  asReference
	 */
	init(destParent, objs, srcMid, srcM, asRef) {
		this.module = MoserObject.getModuleObject(destParent);
		this.objToInsertList = objs;
		this.srcModule = srcM;
		this.asReference = asRef;
		this.srcModuleId = ModuleUtils.getSourceModuleAliasIfNotDefined(srcMid, this.module, this.srcModule);
	}

	/**
	 */
	preInsert() {
		if (!this.module || !this.srcModule || !this.objToInsertList || this.objToInsertList.length==0) {
			return;
		}
		this.idGenerator = ModuleUtils.getIdGenerator(this.module);
		this._getRequiredCustomSorts();
	}

	/**
	 * @param {Object} oldIdToObjectMap
	 */
	postInsert(oldIdToObjectMap) {
		this._updateCustomSortRef(oldIdToObjectMap);
	}

	/**
	 */
	_getRequiredCustomSorts() {
		if (!this.srcModule.basicGetCustomSort() || this.srcModule.basicGetCustomSort().length==0) {
			return;
		}
		this.queryItemWithCustomsortToInsertList = [];
		this.calculationWithCustomsortToInsertList = [];
		var allCustomSorts = {};
		for (var __i_enFor0 = 0, __exp_enFor0 = this.srcModule.basicGetCustomSort(), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var cs = __exp_enFor0[__i_enFor0];
			allCustomSorts[cs.getIdentifier()] = cs;
		}
		this._getObjectsWithCustomsort(allCustomSorts, this.objToInsertList);
		if (this.queryItemWithCustomsortToInsertList.length==0 && this.calculationWithCustomsortToInsertList.length==0) {
			return;
		}
		if (this.asReference) {
			this.refCustomSortOldToNewID = {};
			this._cloneCustomSortAsReference(allCustomSorts, this.queryItemWithCustomsortToInsertList);
		} else {
			this.copyCustomSortOldToNewID = {};
			this._cloneCustomSortAsCopy(allCustomSorts, this.queryItemWithCustomsortToInsertList);
			this._cloneCustomSortAsCopy(allCustomSorts, this.calculationWithCustomsortToInsertList);
		}
	}

	/**
	 * @param {Object} allCustomSorts
	 * @param {Array} objs
	 */
	_cloneCustomSortAsReference(allCustomSorts, objs) {
		var seen = {};
		if (this.module.basicGetCustomSort()) {
			for (var __i_enFor0 = 0, __exp_enFor0 = this.module.basicGetCustomSort(), __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var cs = __exp_enFor0[__i_enFor0];
				seen[cs.getIdentifier()] = cs;
			}
		}
		for (var __i_enFor1 = 0, __exp_enFor1 = objs, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var o = __exp_enFor1[__i_enFor1];
			var facet = o.getFacetDefinition();
			var customSortRef = facet.getCustomSortRef();
			var newCustomID = this.srcModuleId + "." + customSortRef;
			if (!(seen.hasOwnProperty(newCustomID))) {
				var srcCS = allCustomSorts[customSortRef];
				var newCS = srcCS.clone();
				newCS.setEditMode(EditModeType.RO);
				newCS.setIdentifier(newCustomID);
				newCS.setIdForExpression(newCustomID);
				this.module.addCustomSort(newCS);
				seen[newCustomID] = newCS;
				newCS.getPropertyOverride().length = 0;
				newCS.addPropertyOverride("Imported");
			}
			this.refCustomSortOldToNewID[customSortRef] = newCustomID;
			this.bHasRefCustomSortOldToNewID = true;
		}
	}

	/**
	 * @param {Object} allCustomSorts
	 * @param {Array} objs
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	_cloneCustomSortAsCopy(allCustomSorts, objs) {
		for (var __i_enFor0 = 0, __exp_enFor0 = objs, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var o = __exp_enFor0[__i_enFor0];
			var facet = o.getFacetDefinition();
			var customSortRef = facet.getCustomSortRef();
			var srcCS = allCustomSorts[customSortRef];
			var csExist = this._getExistCustomSort(srcCS);
			if (csExist == null) {
				var newCS = srcCS.clone();
				newCS.setEditMode(null);
				this.idGenerator.generateId(newCS);
				csExist = newCS.getIdentifier();
				newCS.setIdForExpression(csExist);
				this.module.addCustomSort(newCS);
			}
			if (!(customSortRef == csExist)) {
				this.copyCustomSortOldToNewID[customSortRef] = csExist;
				this.bHasCopyCustomSortOldToNewID = true;
			}
		}
	}

	/**
	 * @param {Object} allCustomSorts
	 * @param {Array} objList
	 */
	_getObjectsWithCustomsort(allCustomSorts, objList) {
		for (var __i_enFor0 = 0, __exp_enFor0 = objList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var obj = __exp_enFor0[__i_enFor0];
			var objectType = obj.getObjectType();
			if ("QueryItem" == objectType) {
				var qi = obj;
				var items = MoserObjectUtils.getItems(qi);
				items.push(qi);
				this._getUsedCustomSortFromItems(items, allCustomSorts);
				continue;
			}
			if ("Calculation" == objectType) {
				var calc = obj;
				var items = MoserObjectUtils.getItems(calc);
				items.push(calc);
				this._getUsedCustomSortFromItems(items, allCustomSorts);
				continue;
			}
			if ("QuerySubject" == objectType) {
				var items = MoserObjectUtils.getItems(obj);
				this._getUsedCustomSortFromItems(items, allCustomSorts);
				continue;
			}
			if ("FolderItemType" == objectType) {
				var folderItem = obj;
				var folder = folderItem.getFolder();
				var o = folderItem.getReferencedObject();
				if (folder) {
					var folders = [];
					folders.push(folder);
					this._getObjectsWithCustomsort(allCustomSorts, folders);
				} else if (o) {
					var objects = [];
					objects.push(o);
					this._getObjectsWithCustomsort(allCustomSorts, objects);
				}
				continue;
			}
			if ("FolderType" == objectType) {
				var folder = obj;
				var items = folder.basicGetFolderItem();
				if (items && !(items.length==0)) {
					var folderItems = [];
					Array.prototype.push.apply(folderItems, items);
					this._getObjectsWithCustomsort(allCustomSorts, folderItems);
				}
			}
		}
	}

	/**
	 * @param {Array} allItems
	 * @param {Object} allCustomSorts
	 */
	_getUsedCustomSortFromItems(allItems, allCustomSorts) {
		for (var __i_enFor0 = 0, __exp_enFor0 = allItems, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var o = __exp_enFor0[__i_enFor0];
			var facet = null;
			var objectType = o.getObjectType();
			if ("QueryItem" == objectType) {
				facet = (o).getFacetDefinition();
			} else if ("Calculation" == objectType) {
				facet = (o).getFacetDefinition();
			}
			if (this._hasCustomSort(facet, allCustomSorts)) {
				if ("QueryItem" == objectType) {
					this.queryItemWithCustomsortToInsertList.push(o);
				} else {
					this.calculationWithCustomsortToInsertList.push(o);
				}
			}
		}
	}

	/**
	 * @param {FacetType} facet
	 * @param {Object} allCustomSorts
	 * @return {boolean}
	 */
	_hasCustomSort(facet, allCustomSorts) {
		if (!facet || !(FacetTypeEnabled.CUSTOM === facet.getEnabled()) || facet.getCustomSortRef() == null) {
			return false;
		}
		return allCustomSorts.hasOwnProperty(facet.getCustomSortRef());
	}

	/**
	 * @param {CustomSort} srcCS
	 * @return {String}
	 */
	_getExistCustomSort(srcCS) {
		var csList = this.module.basicGetCustomSort();
		if (!csList || csList.length==0) {
			return null;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = csList, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var cs = __exp_enFor0[__i_enFor0];
			if (this._sameList(cs.basicGetValueList(), srcCS.basicGetValueList()) && this._sameCaseSensitive(cs.isCaseSensitiveSearch(), srcCS.isCaseSensitiveSearch()) && this._sameValueSearch(cs.getValueSearch(), srcCS.getValueSearch())) {
				return cs.getIdentifier();
			}
		}
		return null;
	}

	/**
	 * @param {Array} a
	 * @param {Array} b
	 * @return {boolean}
	 */
	_sameList(a, b) {
		if (a.length != b.length) {
			return false;
		}
		for (var i = 0; i < a.length; ++i) {
			if (!(a[i] == b[i])) {
				return false;
			}
		}
		return true;
	}

	/**
	 * @param {Boolean} a
	 * @return {boolean}
	 */
	_checkCaseSensitive(a) {
		if (a == null) {
			return false;
		}
		return a;
	}

	/**
	 * @param {Boolean} a
	 * @param {Boolean} b
	 * @return {boolean}
	 */
	_sameCaseSensitive(a, b) {
		return this._checkCaseSensitive(a) == this._checkCaseSensitive(b);
	}

	/**
	 * @param {ValueSearchType} a
	 * @return {boolean}
	 */
	_checkValueSearchType(a) {
		if (!a) {
			return false;
		}
		return ValueSearchType.EXACT_MATCH === a;
	}

	/**
	 * @param {ValueSearchType} a
	 * @param {ValueSearchType} b
	 * @return {boolean}
	 */
	_sameValueSearch(a, b) {
		return this._checkValueSearchType(a) == this._checkValueSearchType(b);
	}

	/**
	 * @param {Object} oldIdToObjectMap
	 */
	_updateCustomSortRef(oldIdToObjectMap) {
		if (this.asReference) {
			if (this.bHasRefCustomSortOldToNewID) {
				for (var __i_enFor0 = 0, __exp_enFor0 = this.queryItemWithCustomsortToInsertList, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var o = __exp_enFor0[__i_enFor0];
					this._updateObjectCustomSortRef(o, oldIdToObjectMap, this.refCustomSortOldToNewID);
				}
			}
		} else {
			if (this.bHasCopyCustomSortOldToNewID) {
				for (var __i_enFor1 = 0, __exp_enFor1 = this.queryItemWithCustomsortToInsertList, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var o = __exp_enFor1[__i_enFor1];
					this._updateObjectCustomSortRef(o, oldIdToObjectMap, this.copyCustomSortOldToNewID);
				}
				for (var __i_enFor2 = 0, __exp_enFor2 = this.calculationWithCustomsortToInsertList, __len_enFor2 = __exp_enFor2.length;
						__i_enFor2 < __len_enFor2; ++__i_enFor2) {
					var oo = __exp_enFor2[__i_enFor2];
					this._updateObjectCustomSortRef(oo, oldIdToObjectMap, this.copyCustomSortOldToNewID);
				}
			}
		}
	}

	/**
	 * @param {BaseQueryItemType} o
	 * @param {Object} oldIdToObjectMap
	 * @param {Object} oldToNewID
	 */
	_updateObjectCustomSortRef(o, oldIdToObjectMap, oldToNewID) {
		var newObj = this._getNewInsertObject(o, oldIdToObjectMap);
		if (newObj) {
			var facet = newObj.getFacetDefinition();
			if (oldToNewID.hasOwnProperty(facet.getCustomSortRef())) {
				facet.setCustomSortRef(oldToNewID[facet.getCustomSortRef()]);
			}
		}
	}

	/**
	 * @param {BaseQueryItemType} o
	 * @param {Object} oldIdToObjectMap
	 * @return {BaseQueryItemType}
	 */
	_getNewInsertObject(o, oldIdToObjectMap) {
		var objectType = o.getObjectType();
		if ("QueryItem" == objectType) {
			var qs = PropertySetter.getParentQuerySubject(o);
			if (oldIdToObjectMap.hasOwnProperty(qs.getIdentifier())) {
				qs = oldIdToObjectMap[qs.getIdentifier()];
			} else {
				qs = ReferenceResolver.findRefById(qs.getIdentifier(), this.module);
			}
			return ReferenceResolver.getQueryItemByIdAndQuerySubject(o.getIdentifier(), qs, false);
		}
		var calcId = o.getIdentifier();
		var calc = oldIdToObjectMap[calcId];
		if (!calc) {
			var calcs = MoserObjectUtils.getGlobalCalculations(this.module);
			for (var __i_enFor0 = 0, __exp_enFor0 = calcs, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var c = __exp_enFor0[__i_enFor0];
				if (calcId == c.getIdentifier()) {
					calc = c;
					break;
				}
			}
		}
		return calc;
	}

	/**
	 * constructor
	 */
	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/LegacyInsertor.js